module.exports = __webpack_public_path__ + "img/rbcn_pro_show_4.c3be2d79.jpg";